import { MapPin, Clock, Phone, Instagram, Facebook } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { MountainDivider } from '@/components/MountainDivider';
import { trackWhatsappClick } from '@/utils/analytics';

export function Footer() {
  const handleWhatsApp = () => {
    trackWhatsappClick('footer');
    window.open('https://wa.me/+51915976931?text=Hola, quiero información sobre sus productos naturales de Huaytanatura', '_blank');
  };

  const handleSocialLink = (platform: string) => {
    // Placeholder links - replace with actual social media URLs
    const links = {
      instagram: 'https://instagram.com/huaytanatura',
      facebook: 'https://facebook.com/huaytanatura',
      tiktok: 'https://tiktok.com/@huaytanatura'
    };

    window.open(links[platform as keyof typeof links], '_blank');
  };

  return (
    <>
      <MountainDivider svgClassName="text-secondary" heightClass="h-[50px] md:h-[70px] -mb-px bg-background" />
      <footer className="bg-secondary text-secondary-foreground">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Contact Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3 mb-4">
              <img
                src="/logos/favicon.jpg"
                alt=""
                aria-hidden="true"
                className="w-10 h-10 rounded-lg object-cover border border-secondary-foreground/20"
              />
              <h3 className="font-serif text-2xl font-bold">Huaytanatura</h3>
            </div>
            <p className="text-xs uppercase tracking-widest text-secondary-foreground/70 mb-4 -mt-2">
              Productos naturales y harinas andinas
            </p>

            <div className="flex items-start space-x-3">
              <MapPin className="w-5 h-5 text-secondary-foreground/70 mt-0.5 flex-shrink-0" />
              <div>
                <p className="font-medium">Ñaña - Chaclacayo, Lima Este</p>
                <p className="text-sm text-secondary-foreground/70">Carretera Central, Lima · Perú</p>
              </div>
            </div>

            <div className="flex items-center space-x-3">
              <Phone className="w-5 h-5 text-secondary-foreground/70 flex-shrink-0" />
              <div>
                <p className="font-medium">+51 915 976 931</p>
                <p className="text-sm text-secondary-foreground/70">WhatsApp disponible</p>
              </div>
            </div>

            <div className="flex items-center space-x-3">
              <Clock className="w-5 h-5 text-secondary-foreground/70 flex-shrink-0" />
              <div>
                <p className="font-medium">Lun - Sáb: 8:00 AM - 7:00 PM</p>
                <p className="text-sm text-secondary-foreground/70">Dom: 9:00 AM - 7:00 PM</p>
              </div>
            </div>
          </div>

          {/* About */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold mb-4">Nosotros</h3>
            <p className="text-sm text-secondary-foreground/80 leading-relaxed">
              Huaytanatura es el emprendimiento familiar de Grisly Huaytalla, dedicado a
              ofrecer productos naturales y harinas andinas a las familias de Lima Este
              (Ate, Ñaña, Chaclacayo y Chosica). Creemos en la alimentación saludable y
              responsable, sin aditivos químicos.
            </p>
            <p className="text-sm text-secondary-foreground/80">
              <strong>100% naturales • Sin aditivos • Calidad garantizada</strong>
            </p>
          </div>

          {/* Social & WhatsApp */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold mb-4">Síguenos</h3>

            <div className="flex space-x-4 mb-6">
              <Button
                variant="outline"
                size="sm"
                onClick={() => handleSocialLink('instagram')}
                className="border-secondary-foreground/30 text-secondary hover:bg-primary hover:text-primary-foreground hover:border-primary hover:scale-110 transition-all duration-200"
                aria-label="Seguir a Huaytanatura en Instagram"
              >
                <Instagram className="w-4 h-4" aria-hidden="true" />
              </Button>
              <Button
                variant="outline"
                size="sm"
                onClick={() => handleSocialLink('facebook')}
                className="border-secondary-foreground/30 text-secondary hover:bg-primary hover:text-primary-foreground hover:border-primary hover:scale-110 transition-all duration-200"
                aria-label="Seguir a Huaytanatura en Facebook"
              >
                <Facebook className="w-4 h-4" aria-hidden="true" />
              </Button>
            </div>

            <div>
              <h4 className="font-medium mb-2">¿Tienes preguntas?</h4>
              <Button
                onClick={handleWhatsApp}
                className="bg-primary hover:bg-primary-light text-primary-foreground w-full hover:scale-105 transition-all duration-200"
              >
                <Phone className="w-4 h-4 mr-2" />
                Escríbenos por WhatsApp
              </Button>
            </div>
          </div>
        </div>

        <div className="border-t border-secondary-foreground/20 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-center md:text-left">
              <p className="text-sm text-secondary-foreground/70">
                © {new Date().getFullYear()} Huaytanatura. Todos los derechos reservados.
              </p>
            </div>
            <div className="text-center md:text-right">
              <p className="text-sm text-secondary-foreground/70">
                Alimentación natural desde los Andes para tu familia
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
    </>
  );
}